var c = (p, n, r) => new Promise((i, a) => {
  var l = (o) => {
    try {
      m(r.next(o));
    } catch (t) {
      a(t);
    }
  }, s = (o) => {
    try {
      m(r.throw(o));
    } catch (t) {
      a(t);
    }
  }, m = (o) => o.done ? i(o.value) : Promise.resolve(o.value).then(l, s);
  m((r = r.apply(p, n)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import C from "./aiUrgentDialog.ce.vue.js";
import { vCopyVueucStylesToShadowDom as _ } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as g, useTemplateRef as h, withDirectives as y, openBlock as v, createBlock as N, withCtx as d, createVNode as f } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as w } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import D from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const z = /* @__PURE__ */ g({
  __name: "index.ce",
  setup(p, { expose: n }) {
    const r = h("aiUrgentDialogRefs");
    let i = null;
    const a = w(), l = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, s = (o) => c(this, null, function* () {
      var t;
      return (t = r.value) == null || t.open({
        orderId: o.orderId || "",
        notAi: o.notAi || !1,
        productionOrderContractNo: o.productionOrderContractNo || ""
      }), new Promise((u) => {
        i = u;
      });
    }), m = (o) => {
      i && (i(o), i = null);
    };
    return n({ open: s }), (o, t) => y((v(), N(e(D), {
      locale: e(R),
      "date-locale": e(x),
      "theme-overrides": l,
      "style-mount-target": e(a)
    }, {
      default: d(() => [
        f(e(P), { to: e(a) }, {
          default: d(() => [
            f(C, {
              ref_key: "aiUrgentDialogRefs",
              ref: r,
              onSubmit: m
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [e(_), e(a)]
    ]);
  }
});
export {
  z as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-urgent-dialog/index.ce.vue2.js
// module id = 1168
// module chunks = 41